<template>
	<router-view/>
</template>

<script>
export default {
	name: 'Supervisor.vue'
}
</script>

<style scoped>

</style>
